import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "@/api/auth"
import moment from "moment-timezone"

const instaproBaseUrl = `${process.env.INSTAPRO_API_URL}api/v1/`
const baseUrl = `${process.env.PROGUIDES_WEB_URL}api/v2/`

export const getCoachBookingAvailabilities = async (
  instaproToken,
  { coachId, from, to }
) => {
  try {
    const url = `${instaproBaseUrl}student/booking/availabilities`
    const params = {
      coach_id: coachId,
      from,
      to,
    }
    const config = {
      params,
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const getCoachTimeslotsBySessionType = async (
  instaproToken,
  { coachId, gameId, date, type }
) => {
  try {
    const url = `${instaproBaseUrl}student/booking/timeslots/${type}`
    const params = {
      coach_id: coachId,
      game_id: gameId,
      date,
    }
    const config = {
      params,
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const createSessionBooking = async (instaProAccessToken, payload) => {
  try {
    const url = `${baseUrl}instapro/session-request/booking`
    const config = {
      headers: {
        ...getAuthHeaders(),
        "X-INSTA-TOKEN": instaProAccessToken,
      },
    }
    const res = await axios.post(url, payload, config)
    return res.data
  } catch (error) {
    console.error(error)
    return "fail"
  }
}

export const checkInBookedSession = async (instaProAccessToken, bookingId) => {
  try {
    const url = `${instaproBaseUrl}student/booking/${bookingId}/check-in`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.put(url, null, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const getUpcomingSessions = async instaProAccessToken => {
  try {
    const today = moment
      .utc()
      .add(-2, "days")
      .format()
    const to = moment
      .utc()
      .add(10, "years")
      .format()
    const url = `${instaproBaseUrl}student/booking`
    const config = {
      params: {
        from: today,
        to,
      },
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}



// WEBPACK FOOTER //
// ./src/api/student/schedule.js